<div class="configurationBannerHeader" (click)="toggleExpansion()">
  <label class="configurationBannerLabel">Secondary Valve Package</label>
  <span class="spacer"></span>
  <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
</div>
@if (!collapsed) {
  <div class="selectionsWrapper">
    <div class="configurationDetailRow">
      <span class="fullWidthConfigurationInput">
        @if (packageSizeSelection) {
          <span>
            <label class="halfWidthInputLabel">Package Size:</label>
            <select class="halfWidthInputField" #valveSizeInput
              [class.invalidConfigurationSelection]="isInvalidSelection(packageSizeSelection.Name)"
              (change)="selectedValueChanged(packageSizeSelection.Name, valveSizeInput.value)"
              [value]="packageSizeSelection.Value.toString()">
              @for (allowable of packageSizeSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="packageSizeSelection.Value && packageSizeSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </span>
      <span class="fullWidthConfigurationInput">
        @if (strainerSelection) {
          <span>
            <label class="halfWidthInputLabel">Strainer:</label>
            <select class="halfWidthInputField" #strainerInput
              [class.invalidConfigurationSelection]="isInvalidSelection(strainerSelection.Name)"
              (change)="selectedValueChanged(strainerSelection.Name, strainerInput.value)"
              [value]="strainerSelection.Value.toString()">
              @for (allowable of strainerSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="strainerSelection.Value && strainerSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </span>
    </div>
    <div class="configurationDetailRow">
      <span class="fullWidthConfigurationInput">
        @if (controlValveSelection) {
          <span>
            <label class="halfWidthInputLabel">Control Valve:</label>
            <select class="halfWidthInputField" #controlValveInput
              [class.invalidConfigurationSelection]="isInvalidSelection(controlValveSelection.Name)"
              (change)="selectedValueChanged(controlValveSelection.Name, controlValveInput.value)"
              [value]="controlValveSelection.Value.toString()">
              @for (allowable of controlValveSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="controlValveSelection.Value && controlValveSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </span>
      <span class="fullWidthConfigurationInput">
        @if (flowControlTypeSelection) {
          <span>
            <label class="halfWidthInputLabel">Flow Control Type:</label>
            <select class="halfWidthInputField" #flowControlInput
              [class.invalidConfigurationSelection]="isInvalidSelection(flowControlTypeSelection.Name)"
              (change)="selectedValueChanged(flowControlTypeSelection.Name, flowControlInput.value)"
              [value]="flowControlTypeSelection.Value.toString()">
              @for (allowable of flowControlTypeSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="flowControlTypeSelection.Value && flowControlTypeSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </span>
    </div>
    <div class="configurationDetailRow">
      <span class="fullWidthConfigurationInput">
        @if (isolationBallValveSelection) {
          <span>
            <label class="halfWidthInputLabel">Isolation Ball Valve:</label>
            <select class="halfWidthInputField" #isolationBallValveInput
              [class.invalidConfigurationSelection]="isInvalidSelection(isolationBallValveSelection.Name)"
              (change)="selectedValueChanged(isolationBallValveSelection.Name, isolationBallValveInput.value)"
              [value]="isolationBallValveSelection.Value.toString()">
              @for (allowable of isolationBallValveSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="isolationBallValveSelection.Value && isolationBallValveSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </span>
      <span class="fullWidthConfigurationInput">
        @if (hoseKitSelection) {
          <span>
            <label class="halfWidthInputLabel">Hose Kit:</label>
            <select class="halfWidthInputField" #isolationInput
              [class.invalidConfigurationSelection]="isInvalidSelection(hoseKitSelection.Name)"
              (change)="selectedValueChanged(hoseKitSelection.Name, isolationInput.value)"
              [value]="hoseKitSelection.Value.toString()">
              @for (allowable of hoseKitSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="hoseKitSelection.Value && hoseKitSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </span>
    </div>
    @if (comboSupplySelection || comboReturnSelection) {
      <div class="configurationDetailRow">
        <span class="fullWidthConfigurationInput">
          @if (comboSupplySelection) {
            <span>
              <label class="halfWidthInputLabel">Combo Supply:</label>
              <select class="halfWidthInputField" #comboSupplyInput
                [class.invalidConfigurationSelection]="isInvalidSelection(comboSupplySelection.Name)"
                (change)="selectedValueChanged(comboSupplySelection.Name, comboSupplyInput.value)"
                [value]="comboSupplySelection.Value.toString()">
                @for (allowable of comboSupplySelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="comboSupplySelection.Value && comboSupplySelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </span>
        <span class="fullWidthConfigurationInput">
          @if (comboReturnSelection) {
            <span>
              <label class="halfWidthInputLabel">Combo Return:</label>
              <select class="halfWidthInputField" #comboReturnInput
                [class.invalidConfigurationSelection]="isInvalidSelection(comboReturnSelection.Name)"
                (change)="selectedValueChanged(comboReturnSelection.Name, comboReturnInput.value)"
                [value]="comboReturnSelection.Value.toString()">
                @for (allowable of comboReturnSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="comboReturnSelection.Value && comboReturnSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </span>
      </div>
    }
    <div class="configurationDetailRow">
      <span class="fullWidthConfigurationInput">
        @if (serviceFittingsSelection) {
          <span>
            <label class="halfWidthInputLabel">Service Fittings:</label>
            <select class="halfWidthInputField" #serviceFittingsInput
              [class.invalidConfigurationSelection]="isInvalidSelection(serviceFittingsSelection.Name)"
              (change)="selectedValueChanged(serviceFittingsSelection.Name, serviceFittingsInput.value)"
              [value]="serviceFittingsSelection.Value.toString()">
              @for (allowable of serviceFittingsSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="serviceFittingsSelection.Value && serviceFittingsSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </span>
    </div>
  </div>
}
